import { updateChartByPath } from "./chartSlice";

/**
 * Named action creators for Multi-Product Chart (MPC) state updates.
 * Eliminates magic path strings from components and hooks.
 */

export function updateMultiProductProperty(
  id: string,
  property: string,
  value: Primitive
) {
  return updateChartByPath({
    id,
    path: `features.multiProduct.properties.${property}`,
    value
  });
}

export function updateMultiProductActive(id: string, active: boolean) {
  return updateChartByPath({
    id,
    path: "features.multiProduct.active",
    value: active
  });
}

export function updateChartProduct(id: string, product: string) {
  return updateChartByPath({ id, path: "product", value: product });
}

export function updateAnnotationsActive(id: string, active: boolean) {
  return updateChartByPath({
    id,
    path: "features.annotations.active",
    value: active
  });
}
